import { LogoMark } from "./Nav";
import { EMAIL, PHONE_DISPLAY, PHONE_TEL, VIDEO_URL } from "../constants";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-surface/60" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16 py-12 flex flex-col sm:flex-row items-center justify-between gap-8">
        <div className="flex items-center gap-4">
          <LogoMark size={40} />
          <div>
            <p className="font-display font-extrabold tracking-tight text-lg">HULDA PEREZ</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-hdim mt-0.5">
              Vocalist — Acoustic Guitarist — Songwriter
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6 font-mono text-[11px] tracking-[0.15em]">
          <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="text-hmut hover:text-hpink transition-colors">
            {EMAIL}
          </a>
          <a href={`tel:${PHONE_TEL}`} data-testid="footer-phone-link" className="text-hmut hover:text-hpink transition-colors">
            {PHONE_DISPLAY}
          </a>
          <a href="/hulda-perez-press-kit.pdf" target="_blank" rel="noopener noreferrer" data-testid="footer-press-kit-link" className="text-hmut hover:text-hpink transition-colors">
            Press Kit (PDF)
          </a>
        </div>

        <div className="flex items-center gap-8">
          <p className="font-mono text-[10px] tracking-[0.2em] text-hdim">
            © {new Date().getFullYear()} HULDA PEREZ
          </p>
          <a
            href={VIDEO_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-reel-qr"
            className="group flex flex-col items-center gap-1.5"
            aria-label="Scan to watch the vocal reel"
          >
            <span className="block w-16 h-16 rounded-xl bg-white p-1.5 transition-transform duration-300 group-hover:scale-105">
              <img src="/photos/reel-qr.png" alt="QR code to the vocal reel" className="w-full h-full" loading="lazy" />
            </span>
            <span className="font-mono text-[8px] tracking-[0.25em] text-hdim group-hover:text-hblue transition-colors">
              SCAN FOR THE REEL
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
}
